import React from "react";

function Footer() {
  return (
    <footer className="footer py-4">
      <div className="container">
        <div className="row align-items-center">
          <div className="col">Copyright © 2020 John Kaplanis</div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
